import { useMutation } from '@tanstack/react-query';
import { FeatureFlagsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useFeatureFlagsControllerSoftDeleteFeatureFlagMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['featureFlagsControllerSoftDeleteFeatureFlag', accessControlScope],
        mutationFn: async (args) => {
            const api = new FeatureFlagsApi(accessControlConfig);
            return api.featureFlagsControllerSoftDeleteFeatureFlag(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useFeatureFlagsControllerSoftDeleteFeatureFlagMutation.js.map